/* External */
import PropTypes from 'prop-types';
import queryString from 'query-string';
import { compile } from 'path-to-regexp';
import mapValues from 'lodash-es/mapValues';

export const Routes = {
  Logout: route('/logout'),
  ErrorPage: route('/error-page'),
  MessagePage: route('/message-page'),
  Private: route('/private', {
    Home: route('/home'),
    Live: route('/live'),
    OnDemand: route('/on-demand'),
    Sports: route('/sports'),
    Kids: route('/kids'),
    MyList: route('/my-list'),
    MyPage: route('/my-page'),
    Search: route('/search'),
    Setting: route('/setting'),
    AcceptTermsOfService: route('/accept-terms-of-service', {
      Error: route('/error'),
    }),
    TermsOfService: route('/terms-of-service/:page'),
    Interstitial: route('/interstitial'),
    Catalog: route('/collection/:parentCarouselType/:parentCarouselId/:bannerId'),
    Detail: route('/detail', {
      Vod: route('/vod/:contentId'),
      Show: route('/shows/:showId'),
      Live: route('/live/:channelId'),
      Section: route('/section/:source/:type/:sourceCarouselId'),
    }),
    Player: route('/player', {
      Vod: route('/vod/:contentId'),
      Live: route('/live/:channelId'),
      Error: route('/error'),
    }),
    Lander: route('/lander/:pageId'),
    Onboarding: route('/:country?/onboarding'),
    Profiles: route('/:country?/profiles', {
      Management: route('/management'),
      Create: route('/create', {
        Name: route('/name'),
        AllowedContent: route('/allowed-content'),
        Confirmation: route('/confirmation'),
        Resume: route('/resume/:name'),
      }),
      Edit: route('/edit/:id', {
        Name: route('/name'),
        AllowedContent: route('/allowed-content'),
      }),
      Delete: route('/delete/:id'),
      Error: route('/error'),
    }),
  }),
  Public: route('/public', {
    PinLogin: route('/pin-login'),
    WelcomePage: route('/welcome-page'),
    CreateAccount: route('/create-account'),
  }),
};

export const RouteShape = PropTypes.shape({
  path: PropTypes.string,
  getLink: PropTypes.func,
});

function getSubroutes(path, subroutes) {
  return mapValues(subroutes, (subroute) => {
    const { path: subroutePath, getLink: g, ...subSubroutes } = subroute;
    const computedSubroutes = getSubroutes(path, subSubroutes);

    const definitivePath = `${path}${subroutePath}`;
    return {
      ...computedSubroutes,
      path: definitivePath,
      getLink: compile(definitivePath),
    };
  });
}

function route(path, subroutes) {
  const computedSubroutes = subroutes ? getSubroutes(path, subroutes) : {};

  return {
    ...computedSubroutes,
    path,
    getLink: compile(path),
  };
}

export function getPath(routeToGetPath) {
  return routeToGetPath.path;
}

export function getLink(routeToGetLink, params) {
  let search = '';
  if (params?.query) {
    search = `?${queryString.stringify(params?.query)}`;
  }
  return `${routeToGetLink.getLink(params)}${search}`;
}
